import React, { ReactNodeArray } from "react";
import { Icon, Popup } from "semantic-ui-react";

interface Props {
  children: ReactNodeArray;
}

const DropdownMenu = ({ children }: Props) => (
  <Popup
    basic={true}
    header=""
    hoverable={false}
    on={"click"}
    content={children}
    position="bottom right"
    trigger={<Icon name="table" id="show-hide-columns" />}
    wide={true}
  />
);

export default DropdownMenu;
